import { Divider, Stack, Typography } from "@mui/material";
import { ElementType, ReactNode } from "react";

/**
 * The small uppercase label over a group of figures, controls or cards. It
 * reads as structure, so it does not compete with what it groups.
 */
export const SectionLabel = ({
  children,
  component = "span",
  rule = false,
}: {
  children: ReactNode;
  /** A heading element where the label names a section of the page. */
  component?: ElementType;
  /** Draws a line from the label to the end of the row. */
  rule?: boolean;
}) => {
  const label = (
    <Typography
      variant="caption"
      component={component}
      sx={{
        display: "block",
        fontWeight: 700,
        color: "text.secondary",
        letterSpacing: ".06em",
        textTransform: "uppercase",
        whiteSpace: rule ? "nowrap" : undefined,
      }}
    >
      {children}
    </Typography>
  );

  return rule ? (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
      {label}
      <Divider sx={{ flex: 1 }} />
    </Stack>
  ) : (
    label
  );
};
